module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "full-width": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.scheduleOrdersModal),
      callback: function($$v) {
        _vm.scheduleOrdersModal = $$v
      },
      expression: "scheduleOrdersModal"
    }
  }, [_c('v-card', {
    staticClass: "pa-0"
  }, [_c('v-card-title', {
    staticClass: "pt-4 pb-3"
  }, [_c('v-flex', [_c('h6', [_vm._v("\n          Pedidos\n        ")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right "
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.scheduleOrdersModal = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), (_vm.orders.length > -1) ? _c('v-card-text', {
    staticClass: "pa-3",
    staticStyle: {
      "max-height": "468px"
    }
  }, _vm._l((_vm.orders), function(order) {
    return _c('order', {
      key: order.id,
      attrs: {
        "value": order
      },
      on: {
        "details": function($event) {
          return _vm.details($event)
        }
      }
    })
  }), 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e01e29aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/agendamento/OrdersList.vue
// module id = 775
// module chunks = 0